export function convertSecondsToTime(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;
    if(hours==0){
        return `${minutes}:${remainingSeconds}`
    }
    return `${hours}:${minutes}:${remainingSeconds}`
}

// 格式化观看次数
export const formatViews = (num) => {
  if (num >= 1000) return `${(num / 1000).toFixed(1)}K`;
  return num;
};

/**
 * 提取博主名
 * 优先匹配 "原创：#xxx"，如果没匹配到，则匹配第一个 # 和空格之间的字符串
 * @param {string} caption - 文本内容
 * @returns {string} 博主名
 */
export const extractBloggerPhoto = (caption) => {
  if (!caption) return '';

  // ✅ 优先匹配 “原创：#xxx”
  let match = caption.match(/原创：#(\S+)/);

  // ✅ 如果原创没匹配到，则匹配第一个 # 和空格之间的字符串
  if (!match) {
    match = caption.match(/#(\S+?)(?=\s|$)/);
  }

  // ✅ 返回捕获组结果
  return match?.[1] ? match[1].trim() : '';
};


/**
 * 提取博主名
 * 优先匹配 "原创：#xxx"，如果没匹配到，则匹配第一个 # 和空格之间的字符串
 * @param {string} caption - 文本内容
 * @returns {string} 博主名
 */
export const extractBlogger = (caption) => {
  if (!caption) return '';

  // 优先匹配 "原创：#xxx"
  let match = caption.match(/原创：#(\S+)/)+"\u200B"

  // 如果原创没匹配到，则匹配第一个 # 和空格之间的字符串
  if (!match) {
    match = caption.match(/#(\S+?)(?=\s|$)/)
  }

  return match?.[1] || '';
}


export const parseTimestamp = (timestamp) => {
    timestamp = timestamp * 1000;
    let date = new Date(timestamp);
    date.setHours(date.getHours() + 8);
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    const h = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');
    const s = String(date.getSeconds()).padStart(2, '0');
    return `${y}-${m}-${d} ${h}:${min}:${s}`;
  };

export function getKeywords(text) {
    const regex = /#([^#\s]+)(?=\s|$)/g; // 匹配 # 后面跟随的非空格和 # 的字符
    const matches = [];
    let match;

    // 使用 exec 方法查找所有匹配项
    while ((match = regex.exec(text)) !== null) {
        if(match[1].length < 10){
            matches.push(match[1]); // 将匹配的字符推入数组
        }
        
    }

    return matches;
}

export function getRandom() {
    return Math.floor(Math.random() * 9000000) + 100;
}

export const filterArr = (A,B)=>{
    const result = A.filter(itemA => 
        !B.some(itemB => itemB.id === itemA.id)
    );
    return result
}

// ✅ 只保留第一个 '?'，其余替换为 '&'
export const normalizeUrl = (url) => {
  const firstIndex = url.indexOf("?");
  if (firstIndex === -1) return url; // 没有问号直接返回
  return (
    url.slice(0, firstIndex + 1) +
    url.slice(firstIndex + 1).replace(/\?/g, "&")
  );
};

//从字符串里提取出原创关键字
export const extractTag = (caption) => {
  const text = caption || "";

  // 1️⃣ 匹配 “原创：#example” 或 “原创:#example”
  const originalMatch = text.match(/原创[:：]\s*#([^\s#]+)/);
  if (originalMatch) {
    return originalMatch[1]+'\u200b';
  }

  // 2️⃣ 匹配 “类型：#example” 或 “类型:#example”
  const typeMatch = text.match(/类型[:：]\s*#([^\s#]+)/);
  if (typeMatch) {
    return typeMatch[1];
  }

  // 3️⃣ 匹配全局第一个 #xxx（在没有原创和类型时）
  const firstTagMatch = text.match(/#([^\s#]+)/);
  if (firstTagMatch) {
    return firstTagMatch[1];
  }

  // 4️⃣ 都没有时返回默认值
  return "店长推荐";
};


export const parseStartAppParam=(tel_user)=> {
  if(!tel_user.start_param) return null
  const str = tel_user.start_param
  if (!str) return null;
  const parts = str.split("_");
  const result = {};

  for (let i = 0; i < parts.length - 1; i += 2) {
    const key = parts[i];
    const value = parts[i + 1];
    if (key && value !== undefined) {
      result[key] = value;
    }
  }

  return result;
}

export const parseParameter=(msg)=>{
    if(!msg.text) return ""
    if(msg.text.indexOf('/start') == -1) return
    if(msg.text.length < 7) return
    var parameter = msg.text.slice(6).trim()
    parameter = parameter.replaceAll("_",":")
    parameter = parameter.replaceAll("-",",")
    const parts = parameter.split(","); // 分割字符串
    const obj = {};
    parts.forEach(part => {
            const [key, value] = part.split(":");
            obj[key] = value;
    });
    const jsonStr = JSON.stringify(obj)
    const jsonObj = JSON.parse(jsonStr);
    return JSON.parse(jsonStr);
}

export const parameter = (str)=> {
    // 用正则来切割字符串
    const pairs = str.split(/[_-]/);
    const result = {};
    
    // 遍历每一对，并将其转换为对象属性
    for (let i = 0; i < pairs.length; i += 2) {
        const key = pairs[i];
        const value = parseInt(pairs[i + 1], 10);
        result[key] = value;
    }
    return result;
}

export const isEmpty = (obj) => Object.keys(obj).length === 0;